// extracted by mini-css-extract-plugin
export default {"external":"a7cabc","deprecatedBorderRadius":"b7cabc","hasAnimation":"c7cabc","container":"d7cabc"};